// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"504dd4e2","746":"dfc59dab","842":"ddd1a403","860":"47298a3e","873":"67243032","960":"3f3d93a2"}[chunkId] + ".chunk.css";
};